import { render, staticRenderFns } from "./SettingMode.vue?vue&type=template&id=0ea89a4e&scoped=true"
import script from "./SettingMode.vue?vue&type=script&lang=js"
export * from "./SettingMode.vue?vue&type=script&lang=js"
import style0 from "./SettingMode.vue?vue&type=style&index=0&id=0ea89a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea89a4e",
  null
  
)

export default component.exports